// extracted by mini-css-extract-plugin
export var bounce = "ButtonMenu-module--bounce--2bc3c";
export var button = "ButtonMenu-module--button--6f147";
export var dotMoveLeft = "ButtonMenu-module--dot-move-left--04fd7";
export var dotMoveRight = "ButtonMenu-module--dot-move-right--ead62";
export var gradient = "ButtonMenu-module--gradient--ef41d";
export var separatorWidth = "ButtonMenu-module--separator-width--616e3";